// From https://github.com/aaronpk/pkce-vanilla-js/blob/master/index.html

export function generateRandomString() {
  const array = new Uint32Array(28)
  window.crypto.getRandomValues(array)
  return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('')
}
